module.exports = __webpack_public_path__ + "img/1701390281343-7f9def68-a482-42bf-bc6b-35402197eadf.jpeg.2fea53f4.webp";